import type { DataGridRowSelectionState } from '@ibsys/kit';
import { useCallback, useMemo, useState } from 'react';
import { getSelectedRowIds, toRowSelection } from '@/shared/lib';

/**
 * Отметки записей раздела загрузки. Их ведёт страница, а не список: по ним блок загрузки решает,
 * добавлять записи по файлам или проставлять значения отмеченным.
 */
export const useRecordsPicking = () => {
  const [pickedIds, setPickedIds] = useState<number[]>([]);

  const onRowSelectionChange = useCallback((next: DataGridRowSelectionState) => {
    setPickedIds(getSelectedRowIds(next));
  }, []);

  const rowSelectionOverride = useMemo(
    () => ({ rowSelection: toRowSelection(pickedIds), onRowSelectionChange }),
    [pickedIds, onRowSelectionChange],
  );

  const clearPicked = useCallback(() => setPickedIds([]), []);

  return { pickedIds, rowSelectionOverride, clearPicked };
};
